export default {
  strict: true,
  namespaced: true,
  state: {
    list: [],
    loading: false
  },
  mutations: {
    resetList (state) { state.list = '' },
    setList (state, value) { state.list = value },
    setLoading (state, value) { state.loading = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/airports.js